export const RequestStateBackground = {
  Open: "bg-gray-middle",
  WaitingForCustomerUser: "bg-waiting",
  Resolved: "bg-success",
  Cancelled: "bg-gray-dark",
};

export const RequestStateText = {
  Open: "text-gray-middle",
  WaitingForCustomerUser: "text-waiting",
  Resolved: "text-success",
  Cancelled: "text-gray-dark",
};
